export const GET_ASSET_STATISTICS_LOADING = 'GET_ASSET_STATISTICS_LOADING';
export const GET_ASSET_STATISTICS_SUCCESS = 'GET_ASSET_STATISTICS_SUCCESS';
export const GET_ASSET_STATISTICS_ERROR= 'GET_ASSET_STATISTICS_ERROR';